export const ResidentStatus = Object.freeze({
  NONE: 'NONE',
  GREEN_CARD: 'GREEN_CARD',
  USA_BORN: 'USA_BORN',
  USA_PASSPORT: 'USA_PASSPORT',
  WORK_AUTHORIZATION: 'WORK_AUTHORIZATION',
});
